document.addEventListener('click', async function (event) {
    const button = event.target.closest('.product-card-atc-btn');

    if (!button || button.disabled) return;

    event.preventDefault();
    event.stopPropagation();

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    const originalHtml = button.innerHTML;

    button.disabled = true;
    button.textContent = 'Processing';

    try {
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                id: variantId,
                quantity: 1
            })
        });

        if (!response.ok) {
            throw new Error('Failed to add item to cart');
        }

        await response.json();

        document.dispatchEvent(
            new CustomEvent('dispatch:cart-drawer:refresh')
        );

        document.dispatchEvent(
            new CustomEvent('dispatch:cart-drawer:open')
        );

    } catch (error) {
        console.error('Product card add to cart failed:', error);
    } finally {
        button.disabled = false;
        button.innerHTML = originalHtml;
    }
});